"use strict";
import darkStyles from "../src/express/theme-dark.css.js";
import { Theme } from "../src/Theme.dev.js";
import "../src/express/core.dev.js";
Theme.registerThemeFragment("dark-express", "color", darkStyles);
//# sourceMappingURL=theme-dark.dev.js.map
